import CategoryProductSortOption from '../types/CategoryProductSortOption';
import ProductSortOrderBy from '../types/ProductSortOrderBy';
import SortOrder from '../types/SortOrder';

/**
 * Maps admin/API default sort values to product-list sortKey + sortOrder.
 * Returns null when the value has no shopper-facing sort option (e.g. MODEL).
 */
export const mapDefaultSortOptionToOrder = (defaultSortOption) => {
  if (!defaultSortOption) {
    return null;
  }

  switch (defaultSortOption) {
    case ProductSortOrderBy.RELEVANCE:
      return {
        sortKey: ProductSortOrderBy.RELEVANCE,
        sortOrder: SortOrder.DESC,
      };
    case ProductSortOrderBy.CAMPAIGN_DATE_ADDED:
      return {
        sortKey: ProductSortOrderBy.CAMPAIGN_DATE_ADDED,
        sortOrder: SortOrder.DESC,
      };
    case ProductSortOrderBy.RECOMMENDED_SORT_ORDER:
      return {
        sortKey: ProductSortOrderBy.RECOMMENDED_SORT_ORDER,
        sortOrder: SortOrder.ASC,
      };
    case CategoryProductSortOption.NAME:
      return { sortKey: ProductSortOrderBy.NAME, sortOrder: SortOrder.ASC };
    case CategoryProductSortOption.MANUFACTURER:
      return { sortKey: ProductSortOrderBy.BRAND, sortOrder: SortOrder.ASC };
    case CategoryProductSortOption.CHEAPEST:
      return { sortKey: ProductSortOrderBy.PRICE, sortOrder: SortOrder.ASC };
    case CategoryProductSortOption.MOST_EXPENSIVE:
      return { sortKey: ProductSortOrderBy.PRICE, sortOrder: SortOrder.DESC };
    case CategoryProductSortOption.MOST_SOLD:
    // Test / legacy configs may store the API orderBy key instead of MOST_SOLD.
    case ProductSortOrderBy.SALES:
      return { sortKey: ProductSortOrderBy.SALES, sortOrder: SortOrder.DESC };
    case CategoryProductSortOption.LATEST:
    // New Products page pins orderBy via fixedParams as DATE_ADDED.
    case ProductSortOrderBy.DATE_ADDED:
      return {
        sortKey: ProductSortOrderBy.DATE_ADDED,
        sortOrder: SortOrder.DESC,
      };
    case CategoryProductSortOption.BEST_RATED:
      return {
        sortKey: ProductSortOrderBy.REVIEWS_AVERAGE,
        sortOrder: SortOrder.DESC,
      };
    case CategoryProductSortOption.PRODUCT_NUMBER:
      return { sortKey: ProductSortOrderBy.ID, sortOrder: SortOrder.ASC };
    case CategoryProductSortOption.CATEGORY:
      return { sortKey: ProductSortOrderBy.CATEGORY, sortOrder: SortOrder.ASC };
    case CategoryProductSortOption.DISCOUNT:
      return {
        sortKey: ProductSortOrderBy.DISCOUNT,
        sortOrder: SortOrder.DESC,
      };
    case CategoryProductSortOption.IN_STOCK_QUANTITY:
      return {
        sortKey: ProductSortOrderBy.IN_STOCK_QUANTITY,
        sortOrder: SortOrder.DESC,
      };
    default:
      return null;
  }
};

export const findSortSelectionForDefaultOption = (
  defaultSortOption,
  sortSelections
) => {
  const mapped = mapDefaultSortOptionToOrder(defaultSortOption);
  if (!mapped) {
    return null;
  }

  return (
    sortSelections.find(
      (ss) => ss.sortKey === mapped.sortKey && ss.sortOrder === mapped.sortOrder
    ) || null
  );
};
